import React, { useEffect, useState } from "react";
import { MixpanelEvents, trackEvent } from "../../../../utils/mixpanelTracking";
import { Badge, Page, PageHeader } from "../../../../ui";
import Tabs from "./ui-pending/Tabs";
import SlotHeatmap from "./SlotHeatmap";
import ConductConvert from "./ConductConvert";
import "./slotAnalysis.scss";

type SlotAnalysisTab = "heatmap" | "conduct";

/**
 * AE/TE Slots Dashboard — "Slot Analysis" page (AE Reports).
 * Two views: Slot Heatmap (supply) and Conduct & Convert (demo funnel),
 * backed by artium-admin-service /api/v1/dashboard/*.
 */
const SlotAnalysis: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SlotAnalysisTab>("heatmap");

  useEffect(() => {
    trackEvent(MixpanelEvents.SLOT_ANALYSIS_PAGE_VIEW, {});
  }, []);

  return (
    <Page className="slot-analysis">
      <PageHeader
        eyebrow="Reports"
        title="Slot Analysis"
        subtitle="AE/TE slot supply, demo conduct and conversion · Internal Ops & Marketing"
        actions={
          <div className="sa-role-key">
            <Badge tone="primary">AE — Academic Expert</Badge>
            <Badge tone="success">TE — Teacher Expert</Badge>
          </div>
        }
      />

      <Tabs<SlotAnalysisTab>
        aria-label="Slot analysis views"
        tabs={[
          { id: "heatmap", label: "Slot Heatmap" },
          { id: "conduct", label: "Conduct & Convert" },
        ]}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="sa-view" role="tabpanel">
        {activeTab === "heatmap" && <SlotHeatmap />}
        {activeTab === "conduct" && <ConductConvert />}
      </div>
    </Page>
  );
};

export default SlotAnalysis;
